module.exports = __webpack_public_path__ + "img/icon-first.a2d3e58e.png";